"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _path = _interopRequireDefault(require("../../../helpers/path"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./ProductIcon.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('product-icon');
var ProductIcon = function ProductIcon(_ref) {
  var productManifest = _ref.productManifest,
    iconFileName = _ref.iconFileName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 48 : _ref$size,
    customClass = _ref.customClass;
  if (productManifest.fetching) {
    return null;
  }
  if (iconFileName == null) {
    console.log(iconFileName);
  }
  if (iconFileName && iconFileName.includes('DEFAULT_ICON')) {
    return renderDefaultIcon(size, iconFileName, customClass);
  }
  return /*#__PURE__*/_react["default"].createElement("img", {
    alt: "product icon",
    height: size + 'px',
    className: customClass,
    src: (0, _path["default"])("/local/product-icons/".concat(iconFileName))
  });
};
var renderDefaultIcon = function renderDefaultIcon(size, iconFileName, customClass) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(customClass, " ").concat(bemClasses(null, 'default')),
    style: {
      width: size,
      height: size,
      MozBorderRadius: size / 2,
      WebkitBorderRadius: size / 2,
      borderRadius: size / 2,
      textAlign: 'center',
      fontSize: size * 0.5,
      lineHeight: "".concat(size, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      width: '100%'
    }
  }, iconFileName.charAt(0)));
};
ProductIcon.propTypes = {
  productManifest: _propTypes["default"].object.isRequired,
  iconFileName: _propTypes["default"].string,
  size: _propTypes["default"].number
};
var _default = exports["default"] = ProductIcon;